import type React from "react"

function getCurrentYear() {
  return new Date().getFullYear()
}

const Footer: React.FC = () => {
  return (
    <footer className="fixed bottom-0 left-0 z-[1000] w-full bg-gray-800 border-t border-gray-600 shadow md:flex md:items-center md:justify-between md:p-4 dark:bg-gray-800 dark:border-gray-600 max-h-[60px]">
      <span className="text-sm text-gray-100 sm:text-center dark:text-gray-100">
        <span>
          Omni IQ™ © {getCurrentYear()}{" "}
          <a href="https://www.omnicleanair.com/" className="hover:underline">
            Omni CleanAir
          </a>
        </span>
      </span>
    </footer>
  )
}

export default Footer
